import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="string-validator-options"
export default class extends Controller {
  static targets = ['chars'];

  connect() {
    this.selectElement = document.getElementById('mapped_field_field_sampler')
    this.selectElement.addEventListener('change', this.toggle.bind(this));

    if (this.selectElement.value != 'string') {
      this.charsTarget.parentElement.classList.add('hidden')
      this.charsTarget.parentElement.classList.remove('block')
      this.charsTarget.classList.add('hidden')
      this.charsTarget.classList.remove('block')
      this.charsTarget.value = null;
    }
  }
  
  toggle(event) {
    if (event.target.value == 'string') {
      this.charsTarget.parentElement.classList.remove('hidden');
      this.charsTarget.parentElement.classList.add('block')
      this.charsTarget.classList.remove('hidden');
      this.charsTarget.classList.add('block')
    } else {
      this.charsTarget.parentElement.classList.add('hidden')
      this.charsTarget.parentElement.classList.remove('block')
      this.charsTarget.classList.add('hidden')
      this.charsTarget.classList.remove('block')
      this.charsTarget.value = null;
    }
  }
}
